import { StatusBuilder } from './Components/FiltersBuilder/StatusBuilder';
import { MarketBuilder } from './Components/FiltersBuilder/MarketBuilder';
import { CountyBuilder } from './Components/FiltersBuilder/CountyBuilder';
import { SourceBuilder } from './Components/FiltersBuilder/SourceBuilder';

export const OFFER_FILTER_CONFIG = [
  {
    title: 'Status',
    value: 'status',
    builder: StatusBuilder,
  },
  {
    title: 'Market',
    value: 'market',
    builder: MarketBuilder,
  },
  {
    title: 'County',
    value: 'county',
    builder: CountyBuilder,
  },
  {
    title: 'Source',
    value: 'source',
    builder: SourceBuilder,
  },
];
